import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
// import { useDemo } from '../../state/DemoContext'; // Unused
// import { formatCurrency } from '../../utils/helpers'; // Unused import
import './landing.css';

const Landing = () => {
  const history = useHistory();
  // const { state } = useDemo(); // Unused
  const [activeDemo, setActiveDemo] = useState('overview');

  // Stats removed - simplified hero section

  const features = [
    {
      icon: '🏪',
      title: 'Two-Sided Marketplace',
      description: 'Connect asset owners with qualified investors for asset-backed lending across all asset classes.',
      demo: 'marketplace'
    },
    {
      icon: '🤖',
      title: 'AI-Powered Agents',
      description: 'Automated underwriting, encumbrance detection, and risk assessment.',
      demo: 'agents'
    },
    {
      icon: '📊',
      title: 'Real-Time Analytics',
      description: 'Live borrowing base calculations and portfolio monitoring.',
      demo: 'borrowing-base'
    },
    {
      icon: '🔗',
      title: 'System Integration',
      description: 'Connect with NetSuite, QuickBooks, and manual entry systems.',
      demo: 'connect'
    }
  ];

  const userTypes = [
    {
      title: 'Asset Owners',
      description: 'List your assets for asset-backed lending',
      features: [
        'Create detailed asset listings',
        'Set financing terms and requirements',
        'Track investor interest and commitments',
        'Manage multiple asset classes'
      ],
      cta: 'List Your Asset',
      action: () => history.push('/jo-xyz-demo/list-asset'),
      icon: '🏢'
    },
    {
      title: 'Investors',
      description: 'Discover and invest in asset-backed lending opportunities',
      features: [
        'Browse curated investment opportunities',
        'Set investment mandates and criteria',
        'Commit to funding with transparent terms',
        'Track portfolio performance'
      ],
      cta: 'Start Investing',
      action: () => history.push('/jo-xyz-demo/investor/signup'),
      icon: '💰'
    },
    {
      title: 'Lenders',
      description: 'Access comprehensive lending tools',
      features: [
        'Automated underwriting workflows',
        'Real-time risk assessment',
        'Portfolio monitoring and alerts',
        'Integration with existing systems',
        'Collateral liquidation support for defaults'
      ],
      cta: 'Explore Tools',
      action: () => history.push('/jo-xyz-demo/overview'),
      icon: '🏦'
    }
  ];

  const productTypes = [
    {
      title: 'Traditional ABL',
      description: 'Asset-backed loans with fixed terms and collateral',
      features: [
        'Fixed-term loans secured by assets',
        'Traditional underwriting process',
        'Clear collateral requirements',
        'Standard repayment schedules'
      ],
      cta: 'Explore ABL',
      action: () => history.push('/jo-xyz-demo/overview'),
      icon: '📊'
    },
    {
      title: 'Revolving Credit Lines',
      description: 'Flexible credit lines backed by asset collateral',
      features: [
        'Revolving credit with asset backing',
        'Flexible draw and repayment',
        'Dynamic collateral monitoring',
        'Real-time credit availability'
      ],
      cta: 'View Credit Lines',
      action: () => history.push('/jo-xyz-demo/overview'),
      icon: '🔄'
    },
    {
      title: 'Asset-Backed Credit Cards',
      description: 'Credit cards with collateral that decays over time',
      features: [
        'Credit cards secured by assets',
        'Decaying collateral model',
        'Dynamic credit limits',
        'Real-time risk adjustment'
      ],
      cta: 'Learn More',
      action: () => history.push('/jo-xyz-demo/overview'),
      icon: '💳'
    }
  ];

  const handleStartDemo = () => {
    history.push('/jo-xyz-demo/overview');
  };

  const handleFeatureDemo = (demo) => {
    setActiveDemo(demo);
    history.push(`/jo-xyz-demo/${demo}`);
  };

  return (
    <div className="jo-xyz-demo-landing-page">
      {/* Hero Section */}
      <section className="jo-xyz-demo-landing-hero">
        <div className="jo-xyz-demo-landing-hero__content">
          <div className="jo-xyz-demo-landing-hero__text">
            <h1 className="jo-xyz-demo-landing-hero__title">
              The Future of Asset-Backed Lending
            </h1>
            <p className="jo-xyz-demo-landing-hero__subtitle">
              Connect asset owners, investors, and lenders through our AI-powered marketplace. 
              Streamline underwriting, reduce risk, and accelerate funding decisions across all asset classes.
            </p>
            <div className="jo-xyz-demo-landing-hero__actions">
              <button
                className="jo-xyz-demo-btn jo-xyz-demo-btn--primary jo-xyz-demo-btn--lg"
                onClick={() => history.push('/jo-xyz-demo/onboard-borrower')}
              >
                Borrower →
              </button>
              <button
                className="jo-xyz-demo-btn jo-xyz-demo-btn--primary jo-xyz-demo-btn--lg"
                onClick={() => history.push('/jo-xyz-demo/onboard-lender')}
              >
                Lender →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="jo-xyz-demo-landing-features">
        <div className="jo-xyz-demo-landing-features__content">
          <div className="jo-xyz-demo-landing-features__header">
            <h2>Powerful Features for Every Stakeholder</h2>
            <p>Our platform brings together the entire asset-backed lending ecosystem with intelligent automation and real-time insights.</p>
          </div>
          <div className="jo-xyz-demo-landing-features__grid">
            {features.map((feature, index) => (
              <div 
                key={index}
                className={`jo-xyz-demo-feature-card ${activeDemo === feature.demo ? 'jo-xyz-demo-feature-card--active' : ''}`}
                onClick={() => handleFeatureDemo(feature.demo)}
              >
                <div className="jo-xyz-demo-feature-card__icon">{feature.icon}</div>
                <h3 className="jo-xyz-demo-feature-card__title">{feature.title}</h3>
                <p className="jo-xyz-demo-feature-card__description">{feature.description}</p>
                <div className="jo-xyz-demo-feature-card__action">
                  <span>Try Demo →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Types Section */}
      <section className="jo-xyz-demo-landing-product-types">
        <div className="jo-xyz-demo-landing-product-types__content">
          <div className="jo-xyz-demo-landing-product-types__header">
            <h2>Multiple Product Types</h2>
            <p>From traditional ABL to innovative asset-backed credit cards, we support the full spectrum of asset-backed lending.</p>
          </div>
          <div className="jo-xyz-demo-landing-product-types__grid">
            {productTypes.map((product, index) => (
              <div key={index} className="jo-xyz-demo-product-type-card">
                <div className="jo-xyz-demo-product-type-card__header">
                  <div className="jo-xyz-demo-product-type-card__icon">{product.icon}</div>
                  <h3 className="jo-xyz-demo-product-type-card__title">{product.title}</h3>
                  <p className="jo-xyz-demo-product-type-card__description">{product.description}</p>
                </div>
                <div className="jo-xyz-demo-product-type-card__features">
                  <ul>
                    {product.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="jo-xyz-demo-product-type-card__action">
                  <button 
                    className="jo-xyz-demo-btn jo-xyz-demo-btn--primary"
                    onClick={product.action}
                  >
                    {product.cta}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* User Types Section */}
      <section className="jo-xyz-demo-landing-user-types">
        <div className="jo-xyz-demo-landing-user-types__content">
          <div className="jo-xyz-demo-landing-user-types__header">
            <h2>Built for Every Role</h2>
            <p>Whether you're an asset owner, investor, or lender, our platform provides the tools you need.</p>
          </div>
          <div className="jo-xyz-demo-landing-user-types__grid">
            {userTypes.map((userType, index) => (
              <div key={index} className="jo-xyz-demo-user-type-card">
                <div className="jo-xyz-demo-user-type-card__header">
                  <div className="jo-xyz-demo-user-type-card__icon">{userType.icon}</div>
                  <h3 className="jo-xyz-demo-user-type-card__title">{userType.title}</h3>
                  <p className="jo-xyz-demo-user-type-card__description">{userType.description}</p>
                </div>
                <div className="jo-xyz-demo-user-type-card__features">
                  <ul>
                    {userType.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="jo-xyz-demo-user-type-card__action">
                  <button 
                    className="jo-xyz-demo-btn jo-xyz-demo-btn--primary"
                    onClick={userType.action}
                  >
                    {userType.cta}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="jo-xyz-demo-landing-how-it-works">
        <div className="jo-xyz-demo-landing-how-it-works__content">
          <div className="jo-xyz-demo-landing-how-it-works__header">
            <h2>How It Works</h2>
            <p>From listing to funding in three simple steps</p>
          </div>
          <div className="jo-xyz-demo-landing-how-it-works__steps">
            <div className="jo-xyz-demo-how-step">
              <div className="jo-xyz-demo-how-step__number">1</div>
            <div className="jo-xyz-demo-how-step__content">
              <h3>List Your Asset</h3>
              <p>Asset owners create detailed listings with financing terms, asset details, and requirements.</p>
              <button 
                className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--sm"
                onClick={() => history.push('/jo-xyz-demo/list-asset')}
              >
                Try Listing
              </button>
            </div>
            </div>
            <div className="jo-xyz-demo-how-step">
              <div className="jo-xyz-demo-how-step__number">2</div>
              <div className="jo-xyz-demo-how-step__content">
                <h3>AI Assessment</h3>
                <p>Our AI agents analyze risk, check encumbrances, and match assets with compatible investors.</p>
                <button 
                  className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--sm"
                  onClick={() => history.push('/jo-xyz-demo/agents')}
                >
                  View Agents
                </button>
              </div>
            </div>
            <div className="jo-xyz-demo-how-step">
              <div className="jo-xyz-demo-how-step__number">3</div>
              <div className="jo-xyz-demo-how-step__content">
                <h3>Secure Funding</h3>
                <p>Investors commit to funding, terms are finalized, and capital is deployed efficiently.</p>
                <button 
                  className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--sm"
                  onClick={() => history.push('/jo-xyz-demo/marketplace')}
                >
                  Browse Listings
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="jo-xyz-demo-landing-cta">
        <div className="jo-xyz-demo-landing-cta__content">
          <h2>Ready to Transform Asset-Backed Lending?</h2>
          <p>Join the future of asset-backed lending with our comprehensive platform.</p>
          <div className="jo-xyz-demo-landing-cta__actions">
            <button 
              className="jo-xyz-demo-btn jo-xyz-demo-btn--primary jo-xyz-demo-btn--lg"
              onClick={handleStartDemo}
            >
              Start Your Demo
            </button>
            <button 
              className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary jo-xyz-demo-btn--lg"
              onClick={() => history.push('/jo-xyz-demo/marketplace')}
            >
              Explore Marketplace
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="jo-xyz-demo-landing-footer">
        <div className="jo-xyz-demo-landing-footer__content">
          <div className="jo-xyz-demo-landing-footer__info">
            <h3>Jo XYZ Demo</h3>
            <p>Experience the future of asset-backed lending</p>
          </div>
          <div className="jo-xyz-demo-landing-footer__links">
            <button 
              className="jo-xyz-demo-landing-footer__link"
              onClick={() => history.push('/jo-xyz-demo/overview')}
            >
              Overview
            </button>
            <button 
              className="jo-xyz-demo-landing-footer__link"
              onClick={() => history.push('/jo-xyz-demo/marketplace')}
            >
              Marketplace
            </button>
            <button 
              className="jo-xyz-demo-landing-footer__link"
              onClick={() => history.push('/jo-xyz-demo/agents')}
            >
              AI Agents
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
